import styled from 'styled-components';

export const Wrapper = styled.div`
  max-width: ${({ theme }) => theme.maxWidth};
  margin: 0 auto;
  display: grid;
  gap: 50px;
`;
